// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConceptCard_link-wrapper__MMuhd {
  height: 100%;
}

.ConceptCard_conceptCard__aujHi {
  height: 100%;
  transition: all 0.3s;
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
  border: 1px solid #e0e0e0;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}
.ConceptCard_conceptCard__aujHi:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  border-color: #d0d0d0;
}
.ConceptCard_conceptCard__aujHi .ant-card-body {
  height: 100%;
  padding: 0;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_cardContent__zD1-H {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 248, 248, 0.9) 100%);
  backdrop-filter: blur(8px);
}
.ConceptCard_conceptCard__aujHi .ConceptCard_header__4cr86 {
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 16px;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_header__4cr86::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: var(--accent-color);
  border-radius: 2px;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_title__mj0el {
  margin-bottom: 0;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
.ConceptCard_conceptCard__aujHi .ConceptCard_titleGradient__UaOeh {
  background: var(--accent-color);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_description__LzUhp {
  color: #333;
  flex-grow: 1;
  margin-bottom: 24px;
  font-size: 14px;
  line-height: 1.6;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 12px;
  border-radius: 8px;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_description__LzUhp .ant-typography-expand {
  color: #333;
  font-size: 12px;
  font-weight: 700;
  text-decoration: underline;
  background-color: rgba(204, 0, 88, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_description__LzUhp .ant-typography-expand:hover {
  background-color: rgba(204, 0, 88, 0.2);
}
.ConceptCard_conceptCard__aujHi .ConceptCard_footer__tOiFd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.ConceptCard_conceptCard__aujHi .ConceptCard_latestYear__-Xavm {
  color: #666;
  font-size: 12px;
  font-weight: 500;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_trend__qOXLh {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_trend__qOXLh .anticon {
  margin-right: 4px;
  font-size: 16px;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_trendPositive__Ihz2x,
.ConceptCard_conceptCard__aujHi .ConceptCard_trendNegative__uyx2O {
  font-weight: bold;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_trendPositive__Ihz2x {
  color: #fff;
  background-color: #52c41a;
}
.ConceptCard_conceptCard__aujHi .ConceptCard_trendNegative__uyx2O {
  color: #fff;
  background-color: #f5222d;
}

.ConceptCard_statsPopover__it-5k {
  min-width: 200px;
}
.ConceptCard_statsPopover__it-5k .ConceptCard_statItem__b\\+YyG {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.ConceptCard_statsPopover__it-5k .ConceptCard_statIcon__cSKNV {
  font-size: 20px;
  color: #333;
  margin-right: 8px;
}
.ConceptCard_statsPopover__it-5k .ConceptCard_statContent__QxNlV {
  display: flex;
  flex-direction: column;
}
.ConceptCard_statsPopover__it-5k .ConceptCard_statTitle__oPfvC {
  color: #666;
  font-size: 12px;
  font-weight: 400;
}
.ConceptCard_statsPopover__it-5k .ConceptCard_statValue__Bu8lV {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.ConceptCard_statsPopoverOverlay__9H1IW .ant-popover-inner-content {
  padding: 16px;
}
.ConceptCard_statsPopoverOverlay__9H1IW .ant-popover-arrow {
  display: none;
}

@media (min-width: 1600px) {
  .ConceptCard_conceptCard__aujHi .ConceptCard_title__mj0el {
    font-size: 22px;
  }
  .ConceptCard_conceptCard__aujHi .ConceptCard_description__LzUhp {
    font-size: 13px;
  }
}
@media (min-width: 2560px) {
  .ConceptCard_conceptCard__aujHi .ConceptCard_title__mj0el {
    font-size: 20px;
  }
  .ConceptCard_conceptCard__aujHi .ConceptCard_description__LzUhp {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/ConceptCard/ConceptCard.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6DAAA;EACA,yBAAA;EACA,0CAAA;AACF;AACE;EACE,4BAAA;EACA,2CAAA;EACA,qBAAA;AACJ;AAEE;EACE,YAAA;EACA,UAAA;AAAJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,+FAAA;EAKA,0BAAA;AALJ;AAQE;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AANJ;AAQI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;AANN;AAUE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AARJ;AAWE;EACE,+BAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,kBAAA;AATJ;AAYE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;AAVJ;AAYI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;AAVN;AAYM;EACE,uCAAA;AAVR;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;AAbJ;AAgBE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,iBAAA;EACA,eAAA;AAfN;AAmBE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,WAAA;EACA,yBAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,yBAAA;AAnBJ;;AAuBA;EACE,gBAAA;AApBF;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,sBAAA;AAtBJ;AAyBE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAxBJ;;AA6BE;EACE,aAAA;AA1BJ;AA6BE;EACE,aAAA;AA3BJ;;AAkCE;EACE;IACE,eAAA;EA/BJ;EAkCE;IACE,eAAA;EAhCJ;AACF;AAmCE;EACE;IACE,eAAA;EAjCJ;EAoCE;IACE,eAAA;EAlCJ;AACF","sourcesContent":[".link-wrapper {\n  height: 100%;\n}\n\n.conceptCard {\n  height: 100%;\n  transition: all 0.3s;\n  border-radius: 16px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n\n  &:hover {\n    transform: translateY(-10px);\n    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);\n    border-color: #d0d0d0;\n  }\n\n  :global(.ant-card-body) {\n    height: 100%;\n    padding: 0;\n  }\n\n  .cardContent {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 24px;\n    background: linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0.9) 0%,\n      rgba(248, 248, 248, 0.9) 100%\n    );\n    backdrop-filter: blur(8px);\n  }\n\n  .header {\n    margin-bottom: 20px;\n    position: relative;\n    padding-bottom: 16px;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 60px;\n      height: 4px;\n      background: var(--accent-color);\n      border-radius: 2px;\n    }\n  }\n\n  .title {\n    margin-bottom: 0;\n    font-size: 24px;\n    font-weight: 700;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  }\n\n  .titleGradient {\n    background: var(--accent-color);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    color: transparent;\n  }\n\n  .description {\n    color: #333;\n    flex-grow: 1;\n    margin-bottom: 24px;\n    font-size: 14px;\n    line-height: 1.6;\n    background-color: rgba(255, 255, 255, 0.5);\n    padding: 12px;\n    border-radius: 8px;\n\n    :global(.ant-typography-expand) {\n      color: #333;\n      font-size: 12px;\n      font-weight: 700;\n      text-decoration: underline;\n      background-color: rgba(204, 0, 88, 0.1);\n      padding: 2px 6px;\n      border-radius: 4px;\n\n      &:hover {\n        background-color: rgba(204, 0, 88, 0.2);\n      }\n    }\n  }\n\n  .footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  .latestYear {\n    color: #666;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .trend {\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n\n    :global(.anticon) {\n      margin-right: 4px;\n      font-size: 16px;\n    }\n  }\n\n  .trendPositive,\n  .trendNegative {\n    font-weight: bold;\n    font-size: 14px;\n    padding: 4px 8px;\n    border-radius: 4px;\n  }\n\n  .trendPositive {\n    color: #fff;\n    background-color: #52c41a;\n  }\n\n  .trendNegative {\n    color: #fff;\n    background-color: #f5222d;\n  }\n}\n\n.statsPopover {\n  min-width: 200px;\n\n  .statItem {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n\n  .statIcon {\n    font-size: 20px;\n    color: #333;\n    margin-right: 8px;\n  }\n\n  .statContent {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .statTitle {\n    color: #666;\n    font-size: 12px;\n    font-weight: 400;\n  }\n\n  .statValue {\n    font-size: 16px;\n    font-weight: 500;\n    color: #333;\n  }\n}\n\n.statsPopoverOverlay {\n  :global(.ant-popover-inner-content) {\n    padding: 16px;\n  }\n\n  :global(.ant-popover-arrow) {\n    display: none;\n  }\n}\n\n.conceptCard {\n  // ... existing styles ...\n\n  @media (min-width: 1600px) {\n    .title {\n      font-size: 22px;\n    }\n\n    .description {\n      font-size: 13px;\n    }\n  }\n\n  @media (min-width: 2560px) {\n    .title {\n      font-size: 20px;\n    }\n\n    .description {\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link-wrapper": `ConceptCard_link-wrapper__MMuhd`,
	"conceptCard": `ConceptCard_conceptCard__aujHi`,
	"cardContent": `ConceptCard_cardContent__zD1-H`,
	"header": `ConceptCard_header__4cr86`,
	"title": `ConceptCard_title__mj0el`,
	"titleGradient": `ConceptCard_titleGradient__UaOeh`,
	"description": `ConceptCard_description__LzUhp`,
	"footer": `ConceptCard_footer__tOiFd`,
	"latestYear": `ConceptCard_latestYear__-Xavm`,
	"trend": `ConceptCard_trend__qOXLh`,
	"trendPositive": `ConceptCard_trendPositive__Ihz2x`,
	"trendNegative": `ConceptCard_trendNegative__uyx2O`,
	"statsPopover": `ConceptCard_statsPopover__it-5k`,
	"statItem": `ConceptCard_statItem__b+YyG`,
	"statIcon": `ConceptCard_statIcon__cSKNV`,
	"statContent": `ConceptCard_statContent__QxNlV`,
	"statTitle": `ConceptCard_statTitle__oPfvC`,
	"statValue": `ConceptCard_statValue__Bu8lV`,
	"statsPopoverOverlay": `ConceptCard_statsPopoverOverlay__9H1IW`
};
export default ___CSS_LOADER_EXPORT___;
